<div class="bom-container">
  <!-- Header with plant selector -->
  <div class="bom-header">
    <div class="bom-title">
      <h3>Bill of Materials</h3>
      <span class="material-number" *ngIf="materialNumber && materialNumber !== 'Pending'">
        Material: {{ materialNumber }}
      </span>
    </div>
    
    <div class="bom-actions">
      <!-- Plant Selector -->
      <div class="plant-selector">
        <label for="plantSelect">Plant:</label>
        <kendo-dropdownlist
          id="plantSelect"
          [data]="plants"
          [textField]="'code'"
          [valueField]="'code'"
          [valuePrimitive]="true"
          [(value)]="selectedPlant"
          (valueChange)="onPlantChange($event)"
          [loading]="plantsLoading"
          [disabled]="bomLoading || !materialNumber || materialNumber === 'Pending'"
          style="width: 120px;">
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            {{ dataItem.code }}
          </ng-template>
        </kendo-dropdownlist>
      </div>
      
      <!-- Refresh Button -->
      <button kendoButton 
              [svgIcon]="refreshIcon" 
              look="flat"
              [disabled]="bomLoading || !materialNumber || materialNumber === 'Pending'"
              (click)="refreshBom()"
              title="Refresh BOM">
      </button>
      
      <!-- Export Button -->
      <button kendoButton 
              [svgIcon]="excelIcon"
              look="flat"
              [disabled]="bomItems.length === 0"
              (click)="exportToExcel()"
              title="Export to Excel">
      </button>
    </div>
  </div>
  
  <!-- Loading State -->
  <div class="bom-loading" *ngIf="bomLoading">
    <kendo-loader type="pulsing" size="medium"></kendo-loader>
    <span>Loading Bill of Materials...</span>
  </div>
  
  <!-- No Material Number -->
  <div class="bom-empty" *ngIf="!bomLoading && (!materialNumber || materialNumber === 'Pending')">
    <span class="k-icon k-font-icon k-i-warning"></span>
    <p>Material number is not yet available.</p>
    <p class="sub-text">The BOM will be displayed once a material number has been assigned to this request.</p>
  </div>
  
  <!-- Error State -->
  <div class="bom-error" *ngIf="!bomLoading && bomError">
    <span class="k-icon k-font-icon k-i-warning"></span>
    <p>{{ bomError }}</p>
    <button kendoButton look="outline" (click)="refreshBom()">Try Again</button>
  </div>
  
  <!-- BOM Grid -->
  <div class="bom-grid" *ngIf="!bomLoading && !bomError && bomLoaded && bomItems.length > 0">
    <!-- Summary -->
    <div class="bom-summary">
      <span class="summary-item">
        <strong>Total Items:</strong> {{ totalItems }}
      </span>
      <span class="summary-item">
        <strong>Total Quantity:</strong> {{ totalQuantity | number }}
      </span>
    </div>
    
    <!-- Grid -->
    <kendo-grid 
      [data]="bomItems"
      [pageSize]="gridPageSize"
      [skip]="gridSkip"
      [pageable]="true"
      [sortable]="true"
      [filterable]="false"
      [resizable]="true"
      [height]="400"
      (pageChange)="onPageChange($event)">
      
      <kendo-grid-column field="itemNumber" title="Item #" [width]="80"></kendo-grid-column>
      <kendo-grid-column field="component" title="Component" [width]="140"></kendo-grid-column>
      <kendo-grid-column field="description" title="Description" [width]="250"></kendo-grid-column>
      <kendo-grid-column field="quantity" title="Qty" [width]="80" format="{0:n2}"></kendo-grid-column>
      <kendo-grid-column field="unit" title="Unit" [width]="70"></kendo-grid-column>
      <kendo-grid-column field="itemCategory" title="Category" [width]="100"></kendo-grid-column>
      <kendo-grid-column field="objectType" title="Type" [width]="100"></kendo-grid-column>
      
    </kendo-grid>
  </div>
  
  <!-- Empty State (loaded but no items) -->
  <div class="bom-empty" *ngIf="!bomLoading && bomLoaded && bomItems.length === 0 && !bomError">
    <span class="k-icon k-font-icon k-i-inbox"></span>
    <p>No BOM items found for this material at plant {{ selectedPlant }}.</p>
    <p class="sub-text">Try selecting a different plant or contact support if you believe this is an error.</p>
  </div>
</div>
